import { useState, useEffect } from 'react';
import createContext from 'constate';

// todo: define this in design system
const breakpoints = {
  TABLET: 600,
  DESKTOP: 850,
  WIDESCREEN: 1440,
};

export interface ScreenSize {
  isWidescreen: boolean;
  isDesktop: boolean;
  isTablet: boolean;
  isPhone: boolean;
}

const getScreenSize = ({ innerWidth }: Window): ScreenSize => {
  return {
    isWidescreen: innerWidth >= breakpoints.WIDESCREEN,
    isDesktop: innerWidth >= breakpoints.DESKTOP && innerWidth < breakpoints.WIDESCREEN,
    isTablet: innerWidth >= breakpoints.TABLET && innerWidth < breakpoints.DESKTOP,
    isPhone: innerWidth < breakpoints.TABLET,
  };
};

const [ScreenSizeContextProvider, useScreenSize] = createContext(() => {
  const [screenSize, setScreenSize] = useState(getScreenSize(window));

  useEffect(() => {
    const listener = (event: Event) => {
      if (event.target instanceof Window) {
        setScreenSize(getScreenSize(event.target));
      }
    };
    window.addEventListener('resize', listener);
    window.addEventListener('orientationchange', listener);

    return function cleanup() {
      window.removeEventListener('resize', listener);
      window.removeEventListener('orientationchange', listener);
    };
  }, []);

  return screenSize;
});

export { ScreenSizeContextProvider, useScreenSize };
